export default __webpack_public_path__ + "static/media/req-res-cycle.7e869325.jpeg";